<template>
    <div class="bg-view bg-primary p-5">
        <b-container id="view-container" class="container bg-light" fluid="lg" variant="light" type="light">
            <h1>Réinitialisation du mot de passe</h1>
            <br>
            <b-overlay :show="loading" spinner-variant="primary">
                <b-container>
                    <b-form @submit.prevent="onSubmit" id="forgotten-password-form">
                        <b-row class="justify-content-md-center">
                            <b-col xs="12" lg="4">
                                <b-form-group
                                    id="input-group-1"
                                    label="Nouveau mot de passe:"
                                    label-for="new-password"
                                >
                                </b-form-group>
                            </b-col>
                            <b-col xs="12" lg="4">
                                <b-form-input
                                    type="password"
                                    id="new-password"
                                    v-model="form.new_password"
                                    placeholder="Votre nouveau mot de passe"
                                    required
                                    maxlength="30"
                                    minlength="8"
                                    :state="isAllowedPwd"
                                    class="input"
                                ></b-form-input>
                                <b-form-invalid-feedback id="input-new-pwd-feedback" class="input-feedback">
                                    Le mot de passe doit contenir entre 8 et 30 caractères.
                                </b-form-invalid-feedback>
                            </b-col>
                        </b-row>

                        <b-row class="justify-content-md-center">
                            <b-col xs="12" lg="4">
                                <b-form-group
                                    id="input-group-1"
                                    label="Répéter nouveau mot de passe:"
                                    label-for="repeat-new-password"
                                >
                                </b-form-group>
                            </b-col>
                            <b-col xs="12" lg="4">
                                <b-form-input
                                    type="password"
                                    id="repeat-ew-password"
                                    v-model="form.confirm_password"
                                    placeholder="Répéter votre nouveau mot de passe"
                                    required
                                    maxlength="30"
                                    minlength="8"
                                    :state="newPwdConfirmed"
                                    class="input"
                                ></b-form-input>
                                <b-form-invalid-feedback id="input-confirm-pwd-feedback" class="input-feedback">
                                    La confirmation ne correspond pas au nouveau mot de passe renseigné.
                                </b-form-invalid-feedback>
                            </b-col>
                        </b-row>
                        <b-button type="submit" :disabled="loading || !isAllowedPwd || !newPwdConfirmed" variant="secondary">Réinitialiser mon mot de passe</b-button>
                    </b-form>
                </b-container>
            </b-overlay>
            <br>
            
            <b-alert :show="showAlert" :variant="alert.variant">
                {{ alert.text }}
                <br>  
                <router-link :to="{name: 'Login'}" class="left-align">
                    <b-button>
                        <b-icon-arrow-left></b-icon-arrow-left> Retourner à la page de connexion
                    </b-button>
                </router-link>
            </b-alert>
        </b-container>
    </div>
</template>

<script>
import publicApi from '@/services/public.js'

export default {
    data() { 
        return {
            form: {
                new_password: "",
                confirm_password: ""
            },
            showAlert: false,
            loading: false,
            alert: {
                variant: "primary",
                text: ""
            }
        }
    },
    computed: {
        isAllowedPwd() {
            if (this.form.new_password == "" || this.form.new_password == null) {
                return null
            }
            else {
                return (this.form.new_password.trim().length < 8 || this.form.new_password.trim().length > 30)? false : true
            }
        },
        newPwdConfirmed() {
            if (this.form.confirm_password == "" || this.form.confirm_password == null) {
                return null
            }
            else {
                return (this.form.new_password.trim() !== this.form.confirm_password.trim())? false : true
            }
        },
    },
    created() {
    },
    methods: {
        async onSubmit() {
            this.showAlert = false
            if (!this.isAllowedPwd || !this.newPwdConfirmed) {
                this.alert.text = "Veuillez vérifier l'exactitude des informations renseignées."
                this.alert.variant = "danger"
            }
            else {
                this.loading = true
                await publicApi.post(`/lsa/resetting/password/${this.$route.params.user}/${this.$route.params.token}`, this.form)
                .then( () => {
                    this.alert.text = "Votre mot de passe a été modifié avec succès. Vous pouvez dès à présent vous identifier sur la plateforme Digital Citizen, en utilisant ce nouveau mot de passe."
                    this.alert.variant = "success"
                })
                .catch( () => {
                    this.alert.text = "Une erreur est survenue lors de la modification de votre mot de passe. Si le problème persiste, Veuillez recommencer la procédure ou vous rapprocher de votre centre de formation."
                    this.alert.variant = "danger"
                })
                this.loading = false
            }
            this.showAlert = true
        },
    },
}
</script>

<style scoped>
h1 {
    word-break: break-word;
}
.form-group {
    margin-top: 8px;
    margin-bottom: 0
}
.row {
    margin-top: 1.5rem;
}
.container {
    font-weight: bold;
}
.btn {
    margin-top: 1.5rem
}
</style>